<template>
  <div class="h-100">
    <div class="container-fluid h-100 bg-image" :style="{ backgroundImage: primaryBg}" >
      <router-view />
	  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: require('@assets/images/misc/logo.png'),
      primaryBg: `url(${require('@assets/images/misc/brink-bg.png')})`,
    };
  },
  computed: {},
  methods: {},
};
</script>

<style>
 .main-app-container {
   height: 100%;
 }
</style>